import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAllExpensesReport = createAsyncThunk(
    'report/fetchAllExpensesReportmontlhy',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/expense/monthlycount/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all expenses Report');
        }
    }
);

export const fetchAllExpensesReportCount = createAsyncThunk(
    'report/fetchAllExpensesReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/expense/count`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all expenses count Report');
        }
    }
);

export const fetchAllRequestCount = createAsyncThunk(
    'report/fetchAllSkillsReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/expense/request`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Skills Report');
        }
    }
);